/**
 * Centralised query key factory.
 *
 * Naming convention:
 *   `queryKeys.<feature>.all`   → matches every query in the feature
 *   `queryKeys.<feature>.lists` → matches all list/paginated queries
 *   `queryKeys.<feature>.list(params)` → a specific list query
 *   `queryKeys.<feature>.detail(id)` → a specific detail query
 */
export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    me: () => [...queryKeys.auth.all, 'me'] as const,
    csrf: () => [...queryKeys.auth.all, 'csrf'] as const,
  },

  users: {
    all: ['users'] as const,
    lists: () => [...queryKeys.users.all, 'list'] as const,
    list: (params: Record<string, unknown>) => [...queryKeys.users.lists(), params] as const,
  },

  predictions: {
    all: ['predictions'] as const,
    markets: () => [...queryKeys.predictions.all, 'markets'] as const,
    market: (id: string) => [...queryKeys.predictions.all, 'market', id] as const,
    userBets: () => [...queryKeys.predictions.all, 'user-bets'] as const,
    leaderboard: () => [...queryKeys.predictions.all, 'leaderboard'] as const,
  },
} as const;
